import styled from 'styled-components'

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0px 24px 0px 24px;
  z-index: 99999;
`

export const SpanEtapas = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: var(--gray400);
`
export const SpanValor = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: var(--gray500);
`
export const SpanNomeLoja = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: var(--gray400);
`
export const SpanLocation = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: var(--gray500);
`
export const SpanEndereco = styled.span`
  font-size: 14px;
  color: var(--gray400);
`
